/**
 * Creates responsive classes for the given weight definition
 * This can be either a number or an array of numbers which
 * represents the weight of the gap between the columns using
 * our normalised weight scale.
 */ const createResponsiveClasses = ({ bsPrefix, responsiveDefinitition })=>{
    if (!bsPrefix || !responsiveDefinitition) {
        return '';
    }
    if (!Array.isArray(responsiveDefinitition)) {
        /**
         * If the responsive definition is not an array we just return the
         * class name with the responsive definition as a suffix
         */ return `${bsPrefix}-${responsiveDefinitition}`;
    }
    /**
     * This is a list of the breakpoints in order of their index.
     * We use this to create the class names for the breakpoints in order
     * to enable responsive behaviour.
     */ const breakpointIndexes = [
        '_-xs-_',
        'sm',
        'md',
        'lg',
        'xl',
        'xxl'
    ];
    return responsiveDefinitition.reduce((responsiveClassNamesConfig, setting, breakpointIndex)=>{
        if (setting === '' || typeof setting !== 'number' && typeof setting !== 'string') {
            /**
             * If the setting is not a number or a string we don't want to create a class name
             * for it.
             */ return responsiveClassNamesConfig;
        }
        const responsiveClassName = [
            `${bsPrefix}`,
            breakpointIndexes[breakpointIndex],
            setting
        ].filter((classNameToken)=>{
            /**
             * Bootstrap classes don't use `xs` but we also need to hold the slot in
             * the breakpointIndexes array, so we filter the empty string here. out here
             */ return classNameToken !== '_-xs-_';
        }).join('-');
        /**
         * We set the class name to true to enable the responsive behaviour.
         * This will be used by the classnames package to create the class name.
         */ responsiveClassNamesConfig[responsiveClassName] = true;
        return responsiveClassNamesConfig;
    }, {});
};

export { createResponsiveClasses };
